import { Theme, styled } from '@mui/material/styles';
import { DataGridPro } from '@mui/x-data-grid-pro';

import { COLORS } from '../../../configs/colors';
import { Box } from '../Box';

export const GridFlexWrapper = styled('div')`
  display: flex;
  height: 100%;
  width: 100%;
  overflow: hidden;
`;

export const GridFlexGrowWrapper = styled('div')`
  flex-grow: 1;
  width: 100%;
  overflow: hidden;
`;

export const StyledDataGrid = styled(DataGridPro)`
  .error-styling {
    color: ${COLORS.Red};
  }
  .normal-styling {
    color: ${COLORS.Black};
  }
  .duplicate-part-styling {
    background-color: ${COLORS.LightRed};
    &:hover {
      background-color: ${COLORS.LightRed};
    }
  }
  .MuiDataGrid-cell {
    align-items: flex-start !important;
  }
  .bold-header-styling {
    font-weight: bold;
    color: ${COLORS.Black};
    background-color: ${COLORS.SubtleGrey};
    font-size: 17px;
  }
  .normal-activity-monitor-styling {
    font-size: 16px;
    color: ${COLORS.Black};
  }
  .new-status-styling {
    font-size: 16px;
    background-color: ${COLORS.SubtleRed};
  }
  .parts-required-status-styling {
    font-size: 16px;
    background-color: ${COLORS.SubtleRed};
  }
  .escalated-status-styling {
    font-size: 16px;
    background-color: ${COLORS.SubtleRed};
  }
`;

export const FilterWithSearchWrapper = styled(Box)`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding-bottom: 15px;
`;

export const FilterWithSearchButtonWrapper = styled(Box)`
  position: relative;
  display: flex;
  align-self: flex-end;
  margin-right: 20px;
  margin-top: -40px;
  gap: 10px;
`;
/**
 * Skins a `DataGrid` to match the v4 tables — the header treatment, type sizes
 * and hairline rules used by `StructureTable` and the detail-page panels.
 *
 * Applied via `sx` rather than the styled wrapper so it stays opt-in: the grids
 * on screens that have not been reskinned keep the look they have.
 */
export const v4GridSx = (theme: Theme) => ({
  border: 'none',
  '& .MuiDataGrid-columnHeaders': {
    borderBottom: `1px solid ${theme.palette.v4.border}`,
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    fontSize: '11px',
    fontWeight: 700,
    letterSpacing: '0.03em',
    textTransform: 'uppercase',
    color: theme.palette.text.secondary,
  },
  '& .MuiDataGrid-cell': {
    fontSize: '12px',
    borderBottom: `1px solid ${theme.palette.v4.border}`,
    // The base styled wrapper pins cells to the top, which leaves the icon
    // buttons and pills in a row sitting proud of their text.
    alignItems: 'center !important',
  },
  '& .MuiDataGrid-row:hover': {
    backgroundColor: theme.palette.v4.tableHover,
  },
  '& .MuiDataGrid-footerContainer': {
    borderTop: `1px solid ${theme.palette.v4.border}`,
    minHeight: 44,
  },
  '& .MuiDataGrid-columnSeparator': { display: 'none' },
});
